import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, setAuthToken } from '../api';

export default function Login({ onLogin }) {
  const [form, setForm]   = useState({ userName: '', password: '' });
  const [error, setError] = useState('');
  const [busy, setBusy]   = useState(false);
  const navigate          = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setBusy(true);
    try {
      const res = await login(form);
      if (res.data.token) setAuthToken(res.data.token);
      if (res.data.firstTime) { navigate('/confirm-password'); return; }
      onLogin(res.data);
      navigate('/server-management');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed.');
    } finally { setBusy(false); }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100" style={{ background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)' }}>
      <div className="card shadow-lg border-0" style={{ width: 400, borderRadius: '1rem', overflow: 'hidden' }}>
        <div className="card-header bg-white border-0 text-center pt-5 pb-2">
          <div className="bg-primary text-white d-inline-flex justify-content-center align-items-center mb-3 shadow-sm" style={{ width: 64, height: 64, borderRadius: '50%' }}>
            <i className="bi bi-hdd-network fs-3" />
          </div>
          <h4 className="fw-bold text-dark mb-0">Welcome Back</h4>
          <p className="text-secondary small mt-1">Please sign in to continue</p>
        </div>
        <div className="card-body px-4 pb-5 pt-0">
          {error && <div className="alert alert-danger py-2 small fw-medium text-center rounded-3">{error}</div>}
          <form onSubmit={handleSubmit} className="mt-3">
            <div className="mb-3">
              <label className="form-label fw-medium text-secondary small mb-1">Username</label>
              <input className="form-control form-control-lg fs-6" placeholder="Enter your username" value={form.userName} autoFocus
                onChange={e => setForm(f => ({ ...f, userName: e.target.value }))} />
            </div>
            <div className="mb-4">
              <label className="form-label fw-medium text-secondary small mb-1">Password</label>
              <input className="form-control form-control-lg fs-6" type="password" placeholder="••••••••••••" value={form.password}
                onChange={e => setForm(f => ({ ...f, password: e.target.value }))} />
            </div>
            <button className="btn btn-primary btn-lg w-100 fs-6 fw-semibold py-2" disabled={busy}>
              {busy ? <span className="spinner-border spinner-border-sm me-2"/> : null}
              Sign In
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
